<script>
import TvBase from '@/components/TV/TvBase';
import MastHead from '@/components/Screen/MastHead';
import IntersticeMastHead from '@/components/Screen/IntersticeMastHead';
import IntersticeTwo from '@/components/Screen/Interstice2';
import IntersticeThree from '@/components/Screen/Interstice3';
import IntersticeFour from '@/components/Screen/Interstice4';
import StudyParameters from '@/components/StudyParameters';
import SensitiveCase from '@/components/Screen/SensitiveCase';
import EnvironmentalImpact from '@/components/Screen/EnvironmentalImpact';
import TransportList from '@/components/Screen/TransportList';
import Screen from '@/components/Screen/';
import AsideBlock from '@/components/Screen/AsideBlock';
import HeaderBlock from '@/components/Screen/HeaderBlock';
import Baseline from '@/components/Screen/Baseline';
import TableBlock from '@/components/Table/';
import BarChart from '@/components/Chart/Bar';
import LineChart from '@/components/Chart/Line';
import BarPlotChart from '@/components/Chart/BarPlot';
import assetProvider from '@/pure/assetProvider';

export default {
  components: {
    TvBase,
    MastHead,
    StudyParameters,
    SensitiveCase,
    EnvironmentalImpact,
    TransportList,
    Screen,
    AsideBlock,
    HeaderBlock,
    Baseline,
    TableBlock,
    BarChart,
    BarPlotChart,
    LineChart,
    IntersticeTwo,
    IntersticeThree,
    IntersticeFour,
    IntersticeMastHead,
  },

  sockets: {
    selectMenu(menu) {
      this.state = menu;
    },

    selectDistribution(distribution) {
      this.distribution = distribution;
    },

    selectFocus(focus) {
      this.focus = focus;
    },

    selectAdvencedMode(mode) {
      this.graphAdvencedMode = mode;
    },

    selectEnvironmentalMode(mode) {
      this.environmentalMode = mode;
    },

    tvData(data) {
      this.screenData = data;
    },

    tvBlob(data) {
      this.$store.dispatch('downloadRawData', data.url).then(result => {
        this.screenData = result;
      });
    },

    tvTransportType(type) {
      this.screenData.currentTransportFilter = type;
    },

    tvSites(sites) {
      this.screenData.sites = sites;
    },

    tvScrollIndex(scrollIndex) {
      this.scrollIndex = scrollIndex;
    },

    tvAverageTime(averageTime) {
      this.screenData.averageTime = averageTime;
    },

    upadteIndex(index) {
      this.index = index;
    },
  },

  methods: {
    buildSiteBlock(site) {
      const { address, name, image, picture_path, index } = site;

      // ne calcule la distribution que si besoin
      const distribution = this.computeTransportDistribution(
        site,
        ['optimized', 'custom'].includes(this.screenData.currentTransportFilter) ? this.screenData.filteredCollaborators : [],
      );

      return {
        idx: index,
        type: 'site',
        name,
        address,
        poi: assetProvider[`poi${index + 1}`],
        image: image || picture_path || assetProvider.placeHolderSite,
        forcedTransport: this.screenData.currentTransportFilter,
        transportDistribution: distribution,
      };
    },

    computeActualSiteTransportDistribution(collaborators) {
      const collaboratorsOptimizedTransport = collaborators.map(c => c.sites.find(s => `${s.id}` === c.details.actualSiteID).optimizedSite);
      const optimizedPrivateCount = Math.round((collaboratorsOptimizedTransport.filter(c => c === 'private').length / collaborators.length) * 100);
      const optimizedPublicCount = 100 - optimizedPrivateCount;

      return {
        optimized: {
          car: optimizedPrivateCount,
          public: optimizedPublicCount,
        },
      };
    },

    computeTransportDistribution(site, collaborators) {
      if (collaborators && collaborators.length > 0) {
        const collaboratorsOptimizedTransport = collaborators.map(c => c.sites.find(s => s.id === site.id).optimizedSite);
        const optimizedPrivateCount = Math.round((collaboratorsOptimizedTransport.filter(c => c === 'private').length / collaborators.length) * 100);
        const optimizedPublicCount = 100 - optimizedPrivateCount;

        const collaboratorsCustomTransport = collaborators.map(c => c.details.transportType);
        const customPrivateCount = Math.round((collaboratorsCustomTransport.filter(c => c === 'private').length / collaborators.length) * 100);
        const customPublicCount = Math.round((collaboratorsCustomTransport.filter(c => c === 'public').length / collaborators.length) * 100);
        const customBicycleCount = Math.round((collaboratorsCustomTransport.filter(c => c === 'bicycle').length / collaborators.length) * 100);

        return {
          custom: {
            car: customPrivateCount,
            public: customPublicCount,
            bicycle: customBicycleCount,
          },
          optimized: {
            car: optimizedPrivateCount,
            public: optimizedPublicCount,
          },
        };
      }

      return {
        custom: {
          car: 0,
          public: 0,
          bicycle: 0,
        },
        optimized: {
          car: 0,
          public: 0,
        },
      };
    },

    computeTrend(value) {
      return {
        trend: value === 0 ? 0 : value < 0 ? 'down' : 'up',
        className: value <= 0 ? 'green' : value > 10 && value <= 30 ? 'orange' : value > 30 ? 'red' : null,
        value: Math.abs(value),
        sub: ' min',
      };
    },

    computeAverageTime(sites) {
      return sites.map((site, idx) => {
        let { details } = site;
        const difference = details.averageTimeDiff;
        return [
          this.buildSiteBlock(site, idx),
          {
            value: details.averageTime,
            sub: ' min',
            className: details.averageTime > 50 ? 'red' : null,
          },
          this.computeTrend(difference),
        ];
      });
    },

    computeImpact(sites, key, ignoreSite) {
      const { filteredCollaboratorsCount } = this.screenData;
      return sites.map((site, idx) => {
        const details = site.details.impact[key];
        const row = [];
        if (!ignoreSite) {
          row.push(this.buildSiteBlock(site, idx));
        }
        row.push({
          entries: [
            {
              value: details.count,
              icon: 'people',
            },
            {
              value: filteredCollaboratorsCount ? Math.round((details.count / filteredCollaboratorsCount) * 100) : 0,
              sub: '%',
              className: Math.round((details.count / filteredCollaboratorsCount) * 100) > 50 ? 'red' : null,
            },
          ],
        });
        row.push(this.computeTrend(details.averageTimeDiff));
        return row;
      });
    },

    computeTimeTable(headerRanges, entries, subInfo) {
      const specifications = [];
      if (subInfo.subHeader) {
        specifications.push({
          type: 'sub-header',
          caption: subInfo.subHeader,
        });
      }
      headerRanges.forEach((item, i) => {
        const current = {
          value: item,
          sub: subInfo.headerSub ? subInfo.headerSub : null,
        };
        if (subInfo.supHeaderCaption) {
          current.supCaption = subInfo.supHeaderCaption[i];
        }
        specifications.push(current);
      });
      return {
        specifications,
        entries,
      };
    },

    comuputesensibleCaseDecay() {
      const { filteredCollaboratorsCount, sites } = this.screenData;
      // const colorRanges = [
      //   {
      //     color: 'green',
      //     range: [0, 2]
      //   },
      //   {
      //     color: 'default',
      //     range: [2, 5]
      //   },
      //   {
      //     color: 'orange',
      //     range: [5, 10]
      //   },
      //   {
      //     color: 'red',
      //     range: [10, 100]
      //   }
      // ]
      return sites.map(site => {
        const details = site.details.impact.sensibleCaseDecay;
        const row = [];
        const percent = filteredCollaboratorsCount ? Math.round((details.count / filteredCollaboratorsCount) * 100) : 0;
        // const className = this.checkRange(percent, colorRanges)
        row.push({
          entries: [
            {
              value: details.count,
              icon: 'people',
              // className
            },
            {
              value: percent,
              sub: '%',
              // className
            },
          ],
        });
        return row;
      });
    },

    checkRange(value, ranges) {
      for (var i = 0; i < ranges.length; i++) {
        if (value >= ranges[i].range[0] && value <= ranges[i].range[1]) {
          return ranges[i].color;
        }
      }
    },
  },
};
</script>
